import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { AppConfigService } from '@core/services/config/app-config.service';
import { TranslatePipe } from 'src/app/core/pipe/translate.pipe';

interface Country {
    id: string;
    name: string;
    img: string;
    route: string;
}

@Component({
    selector: 'app-lang',
    templateUrl: './lang.component.html',
    styleUrls: ['./lang.component.scss'],
    imports: [TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '(keydown.escape)': 'close()',
    },
})
export class LangComponent {
    private appConfig = inject(AppConfigService);

    // Le opzioni sono di fatto link ai domini per lingua: le rendiamo come <a href>
    // reali (accessibili, crawlabili, funzionano senza JS). Selezionare = navigare.
    protected readonly countries: readonly Country[] = [
        { id: 'IT', name: 'Italiano', img: 'images/flags/ITA.webp', route: this.appConfig.webUrlLang('it') },
        { id: 'CO.UK', name: 'English (UK only)', img: 'images/flags/UK.webp', route: this.appConfig.webUrlLang('co.uk') },
        { id: 'FR', name: 'Français', img: 'images/flags/FRA.webp', route: this.appConfig.webUrlLang('fr') },
        { id: 'DE', name: 'Deutsch', img: 'images/flags/GER.webp', route: this.appConfig.webUrlLang('de') },
        { id: 'ES', name: 'Español', img: 'images/flags/SPA.webp', route: this.appConfig.webUrlLang('es') },
        { id: 'COM', name: 'English (World)', img: 'images/flags/COM.webp', route: this.appConfig.webUrlLang('com') },
    ];

    protected readonly selectedId = signal<string>(this.appConfig.domain().toUpperCase() || 'IT');
    protected readonly current = computed<Country>(
        () => this.countries.find((c) => c.id === this.selectedId()) ?? this.countries[0],
    );
    protected readonly isOpen = signal(false);

    protected toggle(): void {
        this.isOpen.update((open) => !open);
    }

    protected close(): void {
        this.isOpen.set(false);
    }
}
